export default __webpack_public_path__ + "static/media/Facial Recognition.ff57f892.PNG";